import styled, { css } from 'styled-components';
import { Colors , FlexBox, Fonts } from '@brg/ui';
import { LayoutConst } from 'core';
import ResizedImageEnhanced from '../ResizedImageEnhanced';

export const MobileSearchBarWrapper = styled(FlexBox)`
  max-width: 100%;
  width: 100%;
  position: relative;

  @media(max-width: 320px) {
    max-width: 300px;
    width: 300px;
    min-width: 300px;
  }

`;

export const SearchInputsWrapper = styled(FlexBox)<{ isResultVisible?: boolean, isProjectEditPage?: boolean }>`
  border: 1px solid ${({ theme }) => theme.tags.modal.search.borderEmpty};
  border-radius: ${({ isResultVisible }) => isResultVisible ? '3px 3px 0 0' : '3px'};
  background-color: ${p => p?.theme.mobileSearch.wrapper.background};
  height: 48x;
  place-items: center;
  padding: 0 16px;
  svg {
    display: block;
    min-width: 16px;
  }

  input {
    padding: 0 0 0 12px;
    border-bottom: none;
    font-size: 13px;
    line-height: 18px;
    letter-spacing: -0.02em;
    font-weight: 400;
    height: 48px;
    color: ${p => p?.theme.mobileSearch.input.color};

    &::placeholder {
      color: ${({ theme }) => theme.commonInput.placeholder};
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 40px;

    input {
      height: 40px;
    }
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    input {
      padding: 0 8px;
      }
    }
  }

  ${p => !p.isProjectEditPage ? css`
    &:hover {
      border: 1px solid ${({ theme }) => theme.tags.modal.search.border};
    }

    &:focus {
      border: 1px solid ${({ theme }) => theme.tags.modal.search.border} !important;
    }

    &:focus-within {
      border: 1px solid ${({ theme }) => theme.tags.modal.search.border};
    }
  ` : css`
    background-color: ${p.theme.projectEdit.inputs.bg};
    border: none;
  `}
`;

export const SearchInput = styled.input.attrs({ className: "--input" })<{ isMobileInput?: boolean }>`
  ${Fonts.Inter.text};
  color: ${(p) => p.theme.tagSearch.inputColor};
  width: 100%;
  height: 32px;
  background: ${p => p?.theme.mobileSearch.wrapper.background};
  border: none;
  border-bottom: 1px solid ${(p) => p.theme.tagSearch.inputColor};
  outline: none;
  z-index: 9997;
  ::placeholder {
    color: ${Colors.geoWhite31};
  }
  ::placeholder {
    color: ${(p) => p.theme.tagSearch.inputColor};
  }
  @media (max-width: ${LayoutConst.screen.m}px) {
    padding: 15px 16px 13px;
    border-bottom: none;
    
    height: initial;
    ::placeholder {
      color: ${Colors.galBlack47};
    }
  }
`;


export const ResultsWrapper = styled.div<{ hide?: boolean }>`
  position: absolute;
  background-color: ${p => p?.theme.mobileSearch.wrapper.background};
  max-height: 200px;
  width: 100%;
  top: 44px;
  z-index: 80000;
  overflow-y: auto;
  overflow-x: hidden;
  border-left: 1px solid ${({ theme }) => theme.tags.modal.search.border};
  border-right: 1px solid ${({ theme }) => theme.tags.modal.search.border};
  border-bottom: 1px solid ${({ theme }) => theme.tags.modal.search.border};
  border-radius: 0 0 3px 3px;
  ::-webkit-scrollbar {
    width: 3px;
    background: ${(p) => p.theme.mobileSearch.scroll.body};
  }
  ::-webkit-scrollbar-thumb {
    background: ${(p) => p.theme.mobileSearch.scroll.body};
  }
  ::-webkit-scrollbar-track {
    background: ${(p) => p.theme.mobileSearch.scroll.background};
  }

  ${p => p.hide ? css`
    display: none;
  `: null}
`;

export const ResultsItem = styled.div`
  display: flex;
  width: 100%;
  height: 64px;
  // border-bottom: 1px solid ${(p) => p.theme.app.ten};
  cursor: pointer;
  transition: background-color 0.2s;
  background-color: ${p => p?.theme.mobileSearch.wrapper.background};
  :hover {
    background-color: ${p => p?.theme.mobileSearch.wrapper.backgroundHover};
  }
  :active {
    background-color: ${Colors.galBlack31};
  }
`;

export const BackdropContainer = styled.div<{ maxHeight?: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  // height: ${p => p.maxHeight ? '300px' : 'auto'};
  height: auto;
  max-height: 300px;
  // z-index: 9998;
`;

export const CloseIconWrapper = styled.div`
  cursor: pointer;
  width: 16px;
  min-width: 16px;
  height: 16px;
  //padding-left: 8px;
  svg {
    width: 16px;
    height: 16px;
  }
`;

export const SearchBarOutside = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
`;

export const ProjectImageWrapper = styled(ResizedImageEnhanced)``;import styled, { css } from 'styled-components';
import { Colors , FlexBox, Fonts } from '@brg/ui';
import { LayoutConst } from 'core';
import ResizedImageEnhanced from '../ResizedImageEnhanced';

export const MobileSearchBarWrapper = styled(FlexBox)`
  max-width: 100%;
  width: 100%;
  position: relative;

  @media(max-width: 320px) {
    max-width: 300px;
    width: 300px;
    min-width: 300px;
  }

`;

export const SearchInputsWrapper = styled(FlexBox)<{ isResultVisible?: boolean, isProjectEditPage?: boolean }>`
  border: 1px solid ${({ theme }) => theme.tags.modal.search.borderEmpty};
  border-radius: ${({ isResultVisible }) => isResultVisible ? '3px 3px 0 0' : '3px'};
  background-color: ${p => p?.theme.mobileSearch.wrapper.background};
  height: 48x;
  place-items: center;
  padding: 0 16px;
  svg {
    display: block;
    min-width: 16px;
  }

  input {
    padding: 0 0 0 12px;
    border-bottom: none;
    font-size: 13px;
    line-height: 18px;
    letter-spacing: -0.02em;
    font-weight: 400;
    height: 48px;
    color: ${p => p?.theme.mobileSearch.input.color};

    &::placeholder {
      color: ${({ theme }) => theme.commonInput.placeholder};
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 40px;

    input {
      height: 40px;
    }
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    input {
      padding: 0 8px;
      }
    }
  }

  ${p => !p.isProjectEditPage ? css`
    &:hover {
      border: 1px solid ${({ theme }) => theme.tags.modal.search.border};
    }

    &:focus {
      border: 1px solid ${({ theme }) => theme.tags.modal.search.border} !important;
    }

    &:focus-within {
      border: 1px solid ${({ theme }) => theme.tags.modal.search.border};
    }
  ` : css`
    background-color: ${p.theme.projectEdit.inputs.bg};
    border: none;
  `}
`;

export const SearchInput = styled.input.attrs({ className: "--input" })<{ isMobileInput?: boolean }>`
  ${Fonts.Inter.text};
  color: ${(p) => p.theme.tagSearch.inputColor};
  width: 100%;
  height: 32px;
  background: ${p => p?.theme.mobileSearch.wrapper.background};
  border: none;
  border-bottom: 1px solid ${(p) => p.theme.tagSearch.inputColor};
  outline: none;
  z-index: 9997;
  ::placeholder {
    color: ${Colors.geoWhite31};
  }
  ::placeholder {
    color: ${(p) => p.theme.tagSearch.inputColor};
  }
  @media (max-width: ${LayoutConst.screen.m}px) {
    padding: 15px 16px 13px;
    border-bottom: none;
    
    height: initial;
    ::placeholder {
      color: ${Colors.galBlack47};
    }
  }
`;


export const ResultsWrapper = styled.div<{ hide?: boolean }>`
  position: absolute;
  background-color: ${p => p?.theme.mobileSearch.wrapper.background};
  max-height: 200px;
  width: 100%;
  top: 44px;
  z-index: 80000;
  overflow-y: auto;
  overflow-x: hidden;
  border-left: 1px solid ${({ theme }) => theme.tags.modal.search.border};
  border-right: 1px solid ${({ theme }) => theme.tags.modal.search.border};
  border-bottom: 1px solid ${({ theme }) => theme.tags.modal.search.border};
  border-radius: 0 0 3px 3px;
  ::-webkit-scrollbar {
    width: 3px;
    background: ${(p) => p.theme.mobileSearch.scroll.body};
  }
  ::-webkit-scrollbar-thumb {
    background: ${(p) => p.theme.mobileSearch.scroll.body};
  }
  ::-webkit-scrollbar-track {
    background: ${(p) => p.theme.mobileSearch.scroll.background};
  }

  ${p => p.hide ? css`
    display: none;
  `: null}
`;

export const ResultsItem = styled.div`
  display: flex;
  width: 100%;
  height: 64px;
  // border-bottom: 1px solid ${(p) => p.theme.app.ten};
  cursor: pointer;
  transition: background-color 0.2s;
  background-color: ${p => p?.theme.mobileSearch.wrapper.background};
  :hover {
    background-color: ${p => p?.theme.mobileSearch.wrapper.backgroundHover};
  }
  :active {
    background-color: ${Colors.galBlack31};
  }
`;

export const BackdropContainer = styled.div<{ maxHeight?: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  // height: ${p => p.maxHeight ? '300px' : 'auto'};
  height: auto;
  max-height: 300px;
  // z-index: 9998;
`;

export const CloseIconWrapper = styled.div`
  cursor: pointer;
  width: 16px;
  min-width: 16px;
  height: 16px;
  //padding-left: 8px;
  svg {
    width: 16px;
    height: 16px;
  }
`;

export const SearchBarOutside = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
`;

export const ProjectImageWrapper = styled(ResizedImageEnhanced)``;